import { getFullPath } from "./Header/Header";
import {
  activeChildDetail,
  appConstants,
  auth_token,
  changeChild,
  ChatAtom,
  childList,
  ChildTimeLineAtom,
  CorAtom,
  GrowthAtom,
  NotificationAtom,
  parentProfile,
} from "../../AtomStore/store";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import { AiOutlineCloseCircle } from "react-icons/ai";
import altProfile from "../../Pages/components/assets/pictures/profile.png";
const ChangeLoginChild = () => {
  const [showOverlay, setShowOverlay] = useAtom(changeChild);
  const [childrenList] = useAtom(childList);
  const [activeChild] = useAtom(activeChildDetail);
  const [, setLoggedInChild] = useAtom(activeChildDetail);
  const [, setTimeline] = useAtom(ChildTimeLineAtom);
  const [, setNotification] = useAtom(NotificationAtom);
  const [, setChat] = useAtom(ChatAtom);
  const [, setCOR] = useAtom(CorAtom);
  const [parent] = useAtom(parentProfile);
  const [, setGrowthAtom] = useAtom(GrowthAtom);

  const [, setToken] = useAtom(auth_token);
  const [constants] = useAtom(appConstants);
  const navigate = useNavigate();

  const handleOnClick = (child) => {
    console.log(child);
    parent.parentType === "Mother"
      ? setToken(child?.mother_access_token)
      : setToken(child?.father_access_token);

    setTimeline(null);
    setNotification(null);
    setChat(null);
    setCOR(null);
    setLoggedInChild(child);
    setShowOverlay(false);
    setGrowthAtom(null);

    navigate("/myProfile");
  };

  const handleImageError = (e) => {
    e.target.src = altProfile;
  };
  return (
    <div
      className={`${
        showOverlay
          ? "fixed bottom-0 w-100 flex items-end justify-center z-50 bg-white rounded-t-2xl border-t-6  border-annual"
          : "hidden"
      }`}
    >
      <div className="flex flex-col gap-3  bg-annual bg-opacity-5 py-2 px-4 w-100 transform overflow-hidden">
        <div className="flex justify-between items-center">
          <h6 className="font-semibold text-lg">Switch Child's</h6>
          <AiOutlineCloseCircle
            className="cursor-pointer"
            fontSize={24}
            color="#19ADE4"
            onClick={() => setShowOverlay(false)}
          />
        </div>
        <div className="flex justify-around">
          {Array.isArray(childrenList)
            ? childrenList.map((ele) => (
                <div className="flex flex-col items-center" key={ele?.id}>
                  <img
                    src={getFullPath(constants, ele?.child_photo)}
                    alt={ele?.name}
                    className={`rounded-full w-15 h-15 cursor-pointer border-3 ${
                      activeChild?.id === ele?.id
                        ? "border-header border-solid"
                        : "border-solid border-gray-200"
                    } `}
                    onClick={() => handleOnClick(ele)}
                    onError={handleImageError}
                  />
                  <span className="text-sm">{ele.name}</span>
                </div>
              ))
            : null}
        </div>
      </div>
    </div>
  );
};

export default ChangeLoginChild;
